import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CNConsultation, CNConsultationType } from 'src/app/models/cnconsultation';

@Component({
  selector: 'app-contact-type-list',
  templateUrl: './contact-type-list.component.html',
  styleUrls: ['./contact-type-list.component.scss']
})
export class ContactTypeListComponent implements OnInit {

  public consultationTypes: string[] = Object.keys(CNConsultationType);
  public selectedType: CNConsultationType;

  @Input() contact: CNConsultation;
  @Output() selected = new EventEmitter<CNConsultationType>();

  constructor() { }

  ngOnInit(): void {
  }

  selectType(type: CNConsultationType) {
    this.selectedType = type;
    this.selected.emit(this.selectedType);
  }
}
